<template>
  <component
    :is="hasLabel ? 'label' : 'span'"
    class="checkbox-v2 inline-flex flex-row items-center gap-2 mb-0"
    :class="disabled ? 'cursor-not-allowed' : 'cursor-pointer'"
  >
    <span class="w-6 h-6 inline-flex items-center justify-center shrink-0">
      <input
        type="checkbox"
        class="semantic-checkbox !m-0"
        :checked="checked"
        :indeterminate.prop="indeterminate"
        :disabled="disabled"
        v-bind="$attrs"
        @change="$emit('change', $event.target.checked)"
      />
    </span>
    <span v-if="hasLabel" class="text-sm leading-5 text-gray-600">
      <slot>{{ label }}</slot>
    </span>
  </component>
</template>

<script>
export default {
  name: 'CheckboxV2',
  inheritAttrs: false,
  model: { prop: 'checked', event: 'change' },
  props: {
    checked: { type: Boolean, default: false },
    indeterminate: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    label: { type: String, default: '' },
  },
  computed: {
    hasLabel() {
      return !!(this.label || this.$slots.default);
    },
  },
};
</script>
